import { render } from "./ModalHistorial.vue?vue&type=template&id=89d7701e"
import script from "./ModalHistorial.vue?vue&type=script&lang=js"
export * from "./ModalHistorial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__